import { kDPIScreen, kStdFooterHeight, enumUnitVal } from "../constants";

export function GetStdFooterHeight(units) {
  if (units == enumUnitVal.inches) return kStdFooterHeight;
  else {
    if (units == enumUnitVal.cm) return kStdFooterHeight * 2.54;
    else return Math.round(kStdFooterHeight * kDPIScreen);
  }
}
